export default {
  auditReport: {
    search: 'Tìm kiếm',
    reset: 'Làm mới',
    export: 'Xuất bản',
    all: 'Tất cả',
    exportSuccess: 'Xuất bản thành công',
    exportError: 'Xuất bản thất bại',
    fetchError: 'Lấy dữ liệu thất bại',
    summary: {
      dateRange: 'Khoảng ngày (+8)',
      dateRequired: 'Vui lòng chọn khoảng ngày',
      reportDate: 'Ngày báo cáo',
      branch: 'Chi nhánh',
      bet: 'Cược',
      payout: 'Trả thưởng',
      ggr: 'GGR',
      headcountOfActive: 'Số người chơi hoạt động',
      totalBet: 'Tổng cược',
      totalPayout: 'Tổng trả thưởng',
      totalGgr: 'Tổng GGR',
      totalActiveHc: 'HC người chơi hoạt động',
    },
    gameType: {
      dateRange: 'Khoảng ngày (+8)',
      dateRequired: 'Vui lòng chọn khoảng ngày',
      reportDate: 'Ngày báo cáo',
      gameType: 'Loại game',
      bet: 'Cược',
      payout: 'Trả thưởng',
      ggr: 'GGR',
    },
    branchGameType: {
      dateRange: 'Khoảng ngày (+8)',
      dateRequired: 'Vui lòng chọn khoảng ngày',
      reportDate: 'Ngày báo cáo',
      branch: 'Chi nhánh',
      gameType: 'Loại game',
      bet: 'Cược',
      payout: 'Trả thưởng',
      ggr: 'GGR',
    },
    provider: {
      dateRange: 'Khoảng ngày (+8)',
      dateRequired: 'Vui lòng chọn khoảng ngày',
      reportDate: 'Ngày báo cáo',
      provider: 'Nhà cung cấp',
      gameType: 'Loại game',
      betCount: 'Số Lượt Cược',
      bet: 'Cược',
      payout: 'Trả thưởng',
      ggr: 'GGR',
      total: 'Tổng',
    },
    providerGameType: {
      dateRange: 'Khoảng ngày (+8)',
      dateRequired: 'Vui lòng chọn khoảng ngày',
      reportDate: 'Ngày báo cáo',
      provider: 'Nhà cung cấp game',
      gameType: 'Loại game',
      platformType: 'Loại nền tảng',
      betCount: 'Số Lượt Cược',
      bet: 'Cược',
      payout: 'Trả thưởng',
      ggr: 'GGR',
      total: 'Tổng',
    },
    gameOrder: {
      betTimeRange: 'Thời gian đặt cược',
      dateRequired: 'Vui lòng chọn khoảng thời gian đặt cược',
      providerFilter: 'Nhà cung cấp (Nền tảng)',
      betId: 'Mã cược',
      betIdPlaceholder: 'Nhập mã cược',
      partnerOrderId: 'Mã đơn đối tác',
      flowIdPlaceholder: 'Nhập mã đơn đối tác',
      userId: 'ID người dùng',
      userIdPlaceholder: 'Nhập ID người dùng',
      userName: 'Tên người dùng',
      memberAccountPlaceholder: 'Nhập chính xác tên người dùng',
      channelType: 'Kênh',
      outletId: 'ID điểm bán',
      gameName: 'Tên game',
      gameType: 'Loại game',
      provider: 'Nhà cung cấp',
      platformType: 'Loại nền tảng',
      platformCode: 'Mã nền tảng',
      gameId: 'ID game',
      gameIdPlaceholder: 'Nhập ID game',
      bet: 'Cược',
      validBets: 'Cược hợp lệ',
      payouts: 'Trả thưởng',
      winLose: 'Thắng/Thua',
      refund: 'Hoàn tiền',
      ggr: 'GGR',
      isBuyFeature: 'Mua tính năng',
      result: 'Kết quả',
      status: 'Trạng thái',
      betTime: 'Thời gian đặt cược',
      settlementTime: 'Thời gian quyết toán',
      detail: 'Thao tác',
      viewDetail: 'Xem chi tiết',
      sportDetail: 'Chi tiết thể thao',
      casinoDetail: 'Chi tiết casino',
      detailField: {
        // thông tin cơ bản (fallback)
        game_name: 'Tên game',
        game_id: 'ID game',
        game_brand: 'Thương hiệu game',
        game_type: 'Loại game',
        // PAGCOR Casino Detail
        liveGameRound: 'Vòng chơi',
        jackpotContribution: 'Đóng góp Jackpot',
        jackpotPayout: 'Trả thưởng Jackpot',
        houseRake: 'House Rake',
        rakeCeiling: 'Rake Ceiling',
        blinds: 'Blinds',
        netWin: 'Thắng ròng',
        // thông tin mở rộng trận đấu (SportEventExtInfo)
        sportName: 'Môn thể thao',
        leagueName: 'Giải đấu',
        eventName: 'Trận đấu',
        matchDateTime: 'Thời gian trận',
        handicap: 'Kèo cược',
        odds: 'Tỷ lệ cược',
        finalScore: 'Tỷ số cuối',
        itemStatus: 'Trạng thái mục',
        settlementStatus: 'Trạng thái quyết toán',
        isLive: 'Trực tiếp',
        yes: 'Có',
        no: 'Không',
      },
    },
    playerCount: {
      dateRange: 'Khoảng ngày (+8)',
      dateRequired: 'Vui lòng chọn khoảng ngày',
      reportDate: 'Ngày báo cáo',
      dailyRegisteredHc: 'ĐK trong ngày (HC)',
      dailyKycVerifiedHc: 'KYC đã duyệt trong ngày (HC)',
      dailyKycPendingHc: 'KYC chờ duyệt trong ngày (HC)',
      activeHc: 'Hoạt động (HC)',
      deactivatedHc: 'Đã vô hiệu (HC)',
    },
    playerAggregator: {
      dateRange: 'Khoảng ngày (+8)',
      dateRequired: 'Vui lòng chọn khoảng ngày',
      reportDate: 'Ngày báo cáo',
      memberAccount: 'Tài Khoản Hội Viên',
      playerIdPlaceholder: 'Khớp chính xác',
      outletId: 'ID điểm bán',
      channelType: 'Kênh',
      pageTotal: 'Tổng Trang Này',
      depositCount: 'Số Lần Nạp',
      depositAmount: 'Số Tiền Nạp',
      withdrawCount: 'Số Lần Rút',
      withdrawAmount: 'Số Tiền Rút',
      totalBetAmount: 'Tổng tiền cược',
      totalPayoutAmount: 'Tổng trả thưởng',
      winLoseAmount: 'Thắng/Thua',
    },
  },
};
